/** @format */

import styled from 'styled-components';

export const StyledTd = styled.td`
  padding: 8px;
  color: var(--grey-500);
  position: relative;
  > a {
    display: contents;
    //height: 100%;
    //width: 100%;
  }
`;
